export default __webpack_public_path__ + "static/media/CoreUI-Icons-Linear-Free.6779cfb1.woff";